var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5724 6.238C13.9502 4.78133 12.8441 3.58418 11.4411 2.84895C10.0381 2.11372 8.42423 1.88552 6.87236 2.20293C5.3205 2.52033 3.92584 3.36387 2.92417 4.59094C1.9225 5.818 1.37527 7.35331 1.375 8.9373V14.4373C1.375 14.802 1.51987 15.1517 1.77773 15.4096C2.03559 15.6674 2.38533 15.8123 2.75 15.8123H7.4482C7.9847 17.0375 8.86628 18.0799 9.98534 18.8124C11.1044 19.545 12.4125 19.9358 13.75 19.9373H19.25C19.6147 19.9373 19.9644 19.7924 20.2223 19.5346C20.4801 19.2767 20.625 18.927 20.625 18.5623V13.0623C20.6247 11.3816 20.0087 9.75922 18.8935 8.50181C17.7783 7.2444 16.2411 6.43906 14.5724 6.238ZM19.25 18.5623H13.75C12.7775 18.5612 11.8225 18.3028 10.9821 17.8133C10.1417 17.3238 9.44581 16.6207 8.965 15.7753C9.90663 15.6776 10.8179 15.3863 11.6416 14.9197C12.4653 14.4531 13.1837 13.8213 13.7516 13.0639C14.3196 12.3065 14.7248 11.4398 14.9419 10.5184C15.159 9.59693 15.1833 8.64055 15.0133 7.70925C16.2192 7.99385 17.2937 8.67731 18.0627 9.64889C18.8317 10.6205 19.25 11.8232 19.25 13.0623V18.5623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatyActive);
export default __webpack_public_path__ + "static/media/daty_active.ea891ee363ec43fc08fc931a82379d50.svg";
export { ForwardRef as ReactComponent };